// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { provideJupyterDesignSystem, jpDateField } from '@jupyter/web-components';
import { provideReactWrapper } from '@microsoft/fast-react-wrapper';
import React from 'react';
const { wrap } = provideReactWrapper(React, provideJupyterDesignSystem());
export const DateField = wrap(jpDateField(), {
    events: { onChange: 'change' }
});
// @ts-expect-error unknown property
DateField.displayName = 'Jupyter.DateField';
